export enum RBIEnv {
  DEV = 'dev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test',
}

export enum GraphQLEnv {
  DEV = 'dev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test',
  LOCAL = 'local',
}

export enum RBIPlatform {
  APP = 'app',
  KIOSK = 'kiosk',
  WEB = 'web',
}

// Only use for logging universal attributes in mParticle
export enum RBIExpandedPlatform {
  IOS = 'iOS',
  ANDROID = 'Android',
  WEB = 'Web',
}

export enum RBIBrand {
  BK = 'bk',
  LTW = 'ltw',
  PLK = 'plk',
  TH = 'th',
}

export enum RBIFullBrandName {
  Popeyes = 'Popeyes',
  TimHortons = 'Tim Hortons',
  BurgerKing = 'Burger King',
  LoveThatWing = 'Love That Wing',
}

export enum RBIAppUriScheme {
  Popeyes = 'popeyes://',
  TimHortons = 'timhortons://',
  BurgerKing = 'burgerking://',
  LoveThatWing = 'ltw://',
}
